import { render } from "./auth-layout.vue?vue&type=template&id=549f7ee3&ts=true"
import script from "./auth-layout.vue?vue&type=script&lang=ts"
export * from "./auth-layout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__